import { ClassKey } from "@const/class.constants";
import { CustomGroup, CustomGroupItemGroup } from "@dto/customGroup.dto";
import { createContext } from "react";
import { RuleGroup } from "src/component/selectItems/XmRuleList";
import { MenuDataNode } from "src/content/configuration/FolderContextMenuBase";

export const CLASS_ORDER = [
  ClassKey.VIRTUALIZATION,
  ClassKey.STORAGE,
  ClassKey.SAN,
  ClassKey.LAN,
  ClassKey.DATABASE,
  ClassKey.CONTAINER,
  ClassKey.CLOUD,
  ClassKey.BACKUP,
  ClassKey.TAPE
] as const;

export interface IndexedCustomGroup extends CustomGroup {
  index: number;
}

export const FoldersContext = createContext<{ folders: MenuDataNode[]; }>(undefined);

export interface FormCg extends Omit<CustomGroup, 'groups'> {
  rules: RuleGroup[];
}

export function groups2Rules(rule: CustomGroupItemGroup): RuleGroup {
  if (!rule.items)
    return { ...rule, items: undefined };

  return { ...rule, items: rule.items.map(item => ({ ...item, disabled: false })) };
}

